import { c as _c } from "react/compiler-runtime";
import { Button, LinkDiagonalIcon, useToast } from "@flat-ui";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { copyToClipboard } from "@utils/ui-utils";
/** Renders copy link button with functionality for specified target URL */
export function CopyLinkButton(t0) {
  const $ = _c(8);
  const {
    logEventParams,
    targetHref
  } = t0;
  const {
    openToast
  } = useToast();
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== logEventParams || $[1] !== openToast || $[2] !== targetHref || $[3] !== trackEvent) {
    t1 = function copyUrl() {
      copyToClipboard(targetHref);
      trackEvent(logEventParams);
      openToast({
        title: "Link copied"
      });
    };
    $[0] = logEventParams;
    $[1] = openToast;
    $[2] = targetHref;
    $[3] = trackEvent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const copyUrl = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LinkDiagonalIcon />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== copyUrl) {
    t3 = <Button variant="ghost" icon={t2} onClick={copyUrl}>Copy link</Button>;
    $[6] = copyUrl;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}